import React from "react";
import i18n from "../../../localization/i18n";
import CandidateProfile from "./CandidateProfile";
import IncomeExpenesDetails from "./IncomeExpenesDetails";
import MonthlyStaticsFirst from "./MonthlyStaticsFirst";
const LeftSideWrapperDB = ({ surplusOrDeficit }) => {
  const getStyle = () => {
    if (i18n.language === "hi") {
      return { top: "25px" };
    } else if (i18n.language === "fr") {
      return { top: "66px" };
    } else if (i18n.language === "es") {
      return { top: "80px" };
    }
    return { top: "56px" };
  };
  return (
    <>
      <div className="dashboard-left-wrapper">
        <div className="row dashboard-sidebar">
          <div className="col-12">
            <CandidateProfile />
            <div className="side-more-info-db row">
              <MonthlyStaticsFirst surplusOrDeficit={surplusOrDeficit} />
            </div>
            <div className="row details-income-exp-mobile" style={getStyle()}>
              <IncomeExpenesDetails />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeftSideWrapperDB;
